<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js' 
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
			};
		},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			showpz: { 
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {},
		methods: {
			jinbrsfzh(e){
				this.$emit("inputjin",this.headobj)
			},
			inputblur(e){
				this.$emit("inputblur",e)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 15,
							colspan: 1
						};
					} else if(rowIndex === 15){
						return {
							rowspan: 9,
							colspan: 1
						};
					} else if(rowIndex === 24){
						return {
							rowspan: 3,
							colspan: 1
						};
					}else{
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}else if(columnIndex === 3){
					if (rowIndex === 24) {
						return {
							rowspan: 1,
							colspan: 2
						};
					}else if (rowIndex === 25) {
						return {
							rowspan: 1,
							colspan: 2
						};
					}else if (rowIndex === 26) {
						return {
							rowspan: 1,
							colspan: 2
						};
					}
				}else if(columnIndex === 4){
					if (rowIndex === 24) {
						return {
							rowspan: 1,
							colspan: 2
						};
					}else if (rowIndex === 25) {
						return {
							rowspan: 1,
							colspan: 2
						};
					}else if (rowIndex === 26) {
						return {
							rowspan: 1,
							colspan: 2
						};
					}
				}else if(columnIndex === 5){
					if (rowIndex === 24) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 25) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 26) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}else if(columnIndex === 6){
					if (rowIndex === 24) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 25) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 26) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			},
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../valueAddedTax/index.less');
</style>
